<template>
  <div>
    <b-modal
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      dialog-class="three-period-bill-modal"
      v-model="modalShow"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title mr-2">直推三期續繳總表</h5>

        <b-button size="sm" variant="warning" @click="convertPdf()">下載PDF</b-button>

        <button type="button" aria-label="Close" class="close" @click="close()">×</button>
      </template>

      <html-to-pdf
        ref="htmlToPdf"
        :isHide="false"
        @handlerCompleted="pdfCompleted"
      >
        <template slot="pdf-content">
          <div :class="{'three-period-bill-pdf': status.resetDom}">
            <div class="contract-data">
              <div>業務：{{ data.sales_number }} {{ data.sales_name }}</div>

              <!-- <b-button variant="success" @click="convertPdf()">下載PDF</b-button> -->
            </div>

            <b-alert show>
              <div class="total-data-area">
                <div>未繳筆數：{{ unpaidCount || 0 }}</div>

                <div>未繳總金額：{{ unpaidTotal }}</div>
              </div>
            </b-alert>

            <tables-page
              :tableData="table_data"
              :tableFields="table_fields"
            >
              <template #cell(receive)="row">
                {{ getBillReceiveMethodText(row.item.receive) }}
              </template>

              <template #cell(M)="row">
                {{ row.item.pay_status.M_unpay_total }}
              </template>

              <template #cell(Y)="row">
                {{ row.item.pay_status.Y_unpay_total }}
              </template>

              <template #cell(F)="row">
                {{ row.item.pay_status.F_unpay_total }}
              </template>

              <template #cell(S)="row">
                {{ row.item.pay_status.S_unpay_total }}
              </template>

              <template #cell(B)="row">
                {{ row.item.pay_status.B_unpay_total }}
              </template>

              <template #cell(MYFSB_total)="row">
                {{ row.item.pay_status.M_unpay_total + row.item.pay_status.Y_unpay_total + row.item.pay_status.F_unpay_total + row.item.pay_status.S_unpay_total + row.item.pay_status.B_unpay_total }}
              </template>
            </tables-page>
          </div>
        </template>
      </html-to-pdf>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>

    <!-- <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      @handlerCompleted="pdfCompleted"
    >
      <template slot="pdf-content">
        <div class="three-period-bill-pdf">
          <div>業務：{{ data.sales_number }} {{ data.sales_name }}</div>

          <b-alert show>
            <div class="total-data-area">
              <div>未繳筆數：{{ table_data.length || 0 }}</div>

              <div>未繳總金額：{{ unpaidTotal }}</div>
            </div>
          </b-alert>

          <tables-page
            :tableData="table_data"
            :tableFields="table_fields"
          >
            <template #cell(receive)="row">
              {{ getBillReceiveMethodText(row.item.receive) }}
            </template>

            <template #cell(m)="row">
              {{ row.item.pay_status.M_unpay_total }}
            </template>

            <template #cell(y)="row">
              {{ row.item.pay_status.Y_unpay_total }}
            </template>

            <template #cell(f)="row">
              {{ row.item.pay_status.F_unpay_total }}
            </template>

            <template #cell(myf_total)="row">
              {{ row.item.pay_status.M_unpay_total + row.item.pay_status.Y_unpay_total + row.item.pay_status.F_unpay_total }}
            </template>
          </tables-page>
        </div>
      </template>

    </html-to-pdf> -->
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import billApi from "@/models/API/billApi";
import { countNoNum, convertRocDate, getBillReceiveMethodText } from "@/models/HELPERS/common.js";
import HtmlToPdf from '@/components/common/HtmlToPdf';

export default {
  name: 'ThreePeriodBillModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    TablesPage,
    HtmlToPdf
  },
  data () {
    return {
      status: {
        isLoading: false
      },
      table_fields: [],
      page: {},
      table_data: [],
      unpaidCount: 0,
      status: {
        resetDom: false
      }
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    // 未繳總金額
    unpaidTotal() {
      return this.table_data.reduce((accumulator, currentValue) => {
        return accumulator + Number(currentValue.pay_status.M_unpay_total) + Number(currentValue.pay_status.Y_unpay_total) + Number(currentValue.pay_status.F_unpay_total) + Number(currentValue.pay_status.S_unpay_total) + Number(currentValue.pay_status.B_unpay_total)
      }, 0);
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) this.getBill();
      },
      immediate: false
    }
  },
  mounted() {
    this.billApi = new billApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.page = Object.assign({}, this.billApi.page);
    },
    convertRocDate,
    getBillReceiveMethodText,
    // 查詢直推三期續繳總表
    getBill() {
      this.status.isLoading = true;

      this.billApi.getBill((response) => {
        const res = response.data;

        this.table_data = [];

        this.status.isLoading = false;
        
        if (res.data.length <= 0) return;

        const period = this.transformFormatAtoB(res.data[0].pay_status)

        this.tableFieldsHandler(period);

        this.page.totalCount = res.total;
        this.unpaidCount = res.unpay_count_total;
        this.table_data = res.data.map((item, index) => {
          return {
            ...item,
            no: countNoNum(this.page, index),
            ...this.transformFormatAtoB(item.pay_status)
          }
        });


      }, this.data, false)
    },
    transformFormatAtoB(obj) {
      let result = {};

      for (const key in obj) {
        const parts = key.split('_');
        const firstPart = parts[0];
        const value = obj[key];

        if (!isNaN(Number(firstPart))) {
          if (value !== null) {
            result[firstPart] = `${obj[`${firstPart}_payment_at`]} ${obj[`${firstPart}_payment_source`] || ''}`.trim();
          } else {
            result[firstPart] = '';
          }
        }
      }

      return result;
    },
    tableFieldsHandler(period) {
      let fields =  [
        {
          key: "no",
          label: "No",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "member_name",
          label: "姓名",
        },
        {
          key: "join_date",
          label: "入會日期"
        },
        {
          key: "pay_name",
          label: "要助人"
        },
        {
          key: "receive",
          label: "帳單領取",
        },
        {
          key: "M",
          label: "月費",
        },
        {
          key: "Y",
          label: "平台年費",
        },
        {
          key: "F",
          label: "手續費",
        },
        {
          key: "S",
          label: "回饋金",
        },
        {
          key: "B",
          label: "墊繳手續費",
        },
        {
          key: "MYFSB_total",
          label: "合計",
        },

      ];

      for (const [key, value] of Object.entries(period)) {
        fields.push(
          {
            key: `${key}`,
            label: `${key}期`,
          }
        )
      }

      this.table_fields = fields;
    },
    async convertPdf() {
      this.status.resetDom = true;

      await this.$nextTick();

      this.$refs.htmlToPdf.generatePdf();
    },
    // PDF產生完成
    pdfCompleted () {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();
    }
  }
}
</script>

<style lang="scss" >
.three-period-bill-modal {
  max-width: 1440px !important;
  .contract-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  .total-data-area {
    display: grid;
    align-items: center;
    justify-content: flex-start;
    grid-template-columns: repeat(2, 1fr);
    text-align: center;
    font-size: 16px;
    > div:not(:last-child) {
      border-right: 1px solid gray;
    }
  }
}

.three-period-bill-pdf {
  font-size: 36px;
  .total-data-area {
    display: grid;
    align-items: center;
    justify-content: flex-start;
    grid-template-columns: repeat(2, 1fr);
    text-align: center;
    font-size: 36px;
    > div:not(:last-child) {
      border-right: 1px solid gray;
    }
  }
  .table-page {
    table {
      font-size: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Modal/ThreePeriodBillModal.vue